import * as React from "react";
import { IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { extractUserInfoFromToken, getLocalStorageSAMLToken } from "../utils";
import { getBulkReport, sortBulkExports } from "../redux/dynamo_db/actions";
import { downloadBulkResult } from "../redux/global/reducer";
import { DataTable, MaterialSymbol } from "@datalake/towercontrol-banner";

const DEFAULT_SORT = { id: "start_time", direction: "desc" };

export default function BulkReport(props) {
  const dispatch = useDispatch();

  const handleGetBulkReport = async () => {
    let queryObject = {};
    const saml_token = getLocalStorageSAMLToken();
    const infoToken = extractUserInfoFromToken(saml_token);
    queryObject.request_user = infoToken.username;
    await dispatch(getBulkReport(queryObject));
    // newest first, also when the user clears the table sort
    dispatch(sortBulkExports("start_time", "descending"));
  };

  React.useEffect(() => {
    handleGetBulkReport();
  }, []);

  const bulkReports = useSelector((state) => {
    if (state.bulkReports) {
      return state.filteredBulkReports.map((report) => {
        return {
          sk: report.SK,
          status: report.status,
          total_data: report.total_data,
          success_data: report.success_data,
          url: report.url,
          errors: report.errors,
          start_time: report.start_time,
          end_time: report.end_time,
          process_time: report.process_time,
          batch_type: report.batch_type,
          input_file: report.input_file,
        };
      });
    } else return [];
  });
  const handleDownload = async (url, filename) => {
    try {
      // Fetch the file from the URL
      const response = await fetch(url);
      const blob = await response.blob();
      downloadBulkResult(blob, filename);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const columns = [
    { id: "batch_type", label: "Batch type", filter: "select" },
    { id: "status", label: "Status", filter: "select" },
    { id: "start_time", label: "Start Time", nowrap: true },
    { id: "end_time", label: "End time", nowrap: true },
    { id: "process_time", label: "Process time", align: "right" },
    { id: "total_data", label: "Total data", align: "right" },
    { id: "success_data", label: "Success count", align: "right" },
    { id: "errors", label: "Errors count", align: "right" },
    {
      id: "url",
      label: "File link",
      sortable: false,
      searchable: false,
      csv: false,
      render: (row) =>
        row?.url ? (
          <IconButton
            size="small"
            aria-label="Download result file"
            onClick={() => handleDownload(row.url, row.input_file)}
          >
            <MaterialSymbol name="download" />
          </IconButton>
        ) : null,
    },
  ];

  return (
    <DataTable
      title="Bulk exports"
      columns={columns}
      rows={bulkReports}
      getRowId={(row, i) => `${row?.sk}-${i}`}
      defaultSort={DEFAULT_SORT}
      defaultRowsPerPage={25}
      size="small"
      emptyMessage="No bulk export yet"
      actions={
        <Button
          variant="outlined"
          startIcon={<MaterialSymbol name="refresh" size="button" />}
          onClick={handleGetBulkReport}
        >
          Reload
        </Button>
      }
      sx={{ mt: 2 }}
    />
  );
}
